import React from "react";
import { twMerge } from "tailwind-merge";

interface HeaderSpacerProps {
  className?: string;
}

const HeaderSpacer = ({ className }: HeaderSpacerProps) => {
  return (
    <div className={twMerge("h-[85px] bg-white lg:h-[110px]", className)} />
  );
};

export default HeaderSpacer;
